"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionsAllocatedProviders_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var User_1 = require("./User");
var Transaction_1 = require("./Transaction");
var TransactionsAllocatedProviders_Factory = /** @class */ (function () {
    function TransactionsAllocatedProviders_Factory() {
    }
    TransactionsAllocatedProviders_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AllocatedAmount: model.AllocatedAmount,
            Provider: User_1.User_Factory.CreateIncoming(model.Provider),
            ProviderId: model.ProviderId,
            RecordId: model.RecordId,
            Transaction: Transaction_1.Transaction_Factory.CreateIncoming(model.Transaction),
        };
        return result;
    };
    TransactionsAllocatedProviders_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AllocatedAmount: model.AllocatedAmount,
            Provider: User_1.User_Factory.CreateOutgoing(model.Provider),
            ProviderId: model.ProviderId,
            RecordId: model.RecordId,
            Transaction: Transaction_1.Transaction_Factory.CreateOutgoing(model.Transaction),
        };
        return result;
    };
    return TransactionsAllocatedProviders_Factory;
}());
exports.TransactionsAllocatedProviders_Factory = TransactionsAllocatedProviders_Factory;
